import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';

export const WebstoreSkeletonTheme: React.FC = ({ children }) => (
  <SkeletonTheme baseColor={'#f5f5f5'} highlightColor={'#fcfcfc'}>
    {children}
  </SkeletonTheme>
);
